import { defineComponent as _defineComponent } from 'vue'
import DesktopSearchBar from "./DesktopSearchBar.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'DataFilter',
  setup(__props) {


return { __sfc: true,DesktopSearchBar }
}

})